import SuccessOverlay from './SuccessOverlay';

export default SuccessOverlay;
